export default {
  activeCarrierMarketsWeekend: {
    id: 'bo_seller.options.shipping.manage_weekend_delivery.active_carrier_markets.weekend',
    defaultMessage: '{saturday}, {sunday}',
  },
  activeCarrierMarketsWeekendDay: {
    id: 'bo_seller.options.shipping.manage_weekend_delivery.active_carrier_markets.weekend_day',
    defaultMessage: '{weekday}: {activeMarkets} active',
  },
}
